import alanyaspor from "../images/logos/alanyaspor-logo.png";
import amedSK from "../images/logos/amed-sk.png";
import basaksehir from "../images/logos/basaksehir-logo.png";
import besiktas from "../images/logos/besiktas-logo.png";
import corumFK from "../images/logos/corum-fk.png";
import erzurumspor from "../images/logos/erzurumspor-fk.png";
import eyupspor from "../images/logos/eyupspor-logo.png";
import fenerbahce from "../images/logos/fenerbahce-logo.png";
import galatasaray from "../images/logos/galatasaray-logo.png";
import gaziantepFK from "../images/logos/gaziantep-fk-logo.png";
import genclerbirligi from "../images/logos/genclerbirligi-logo.png";
import goztepe from "../images/logos/goztepe-logo.png";
import kasimpasa from "../images/logos/kasimpasa-logo.png";
import kocaelispor from "../images/logos/kocaelispor-logo.png";
import konyaspor from "../images/logos/konyaspor-logo.png";
import trabzonspor from "../images/logos/trabzonspor-logo.png";
import rizespor from "../images/logos/rizespor-logo.png";
import samsunspor from "../images/logos/samsunspor-logo.png";

export const logos = {
  alanyaspor: alanyaspor,
  "amed-sk": amedSK,
  basaksehir: basaksehir,
  besiktas: besiktas,
  "corum-fk": corumFK,
  "erzurumspor-fk": erzurumspor,
  eyupspor: eyupspor,
  fenerbahce: fenerbahce,
  galatasaray: galatasaray,
  "gaziantep-fk": gaziantepFK,
  genclerbirligi: genclerbirligi,
  goztepe: goztepe,
  kasimpasa: kasimpasa,
  kocaelispor: kocaelispor,
  konyaspor: konyaspor,
  trabzonspor: trabzonspor,
  samsunspor: samsunspor,
  rizespor: rizespor,
};

export const logosForFullName = {
  Alanyaspor: alanyaspor,
  "Amed SK": amedSK,
  Başakşehir: basaksehir,
  Beşiktaş: besiktas,
  "Çorum FK": corumFK,
  "Erzurumspor FK": erzurumspor,
  Eyüpspor: eyupspor,
  Fenerbahçe: fenerbahce,
  Galatasaray: galatasaray,
  "Gaziantep FK": gaziantepFK,
  Gençlerbirliği: genclerbirligi,
  Göztepe: goztepe,
  Kasımpaşa: kasimpasa,
  Kocaelispor: kocaelispor,
  Konyaspor: konyaspor,
  Trabzonspor: trabzonspor,
  Samsunspor: samsunspor,
  Rizespor: rizespor,
};
